/** 文本通用工具 */
// 使用vue组件的方式混入，无需添加额外白名单混淆
import { Vue, Component } from "vue-property-decorator";
declare var UnitUtil: any;
declare var eUnit: any;
@Component
export default class FontTool extends Vue {
    ft_getMinSize() {
        return getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
    }

    ft_checkSizeOK(data: number) {
        let minFontPx = getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
        let minFontPt = UnitUtil.pixelToUnit(minFontPx, eUnit.pt);
        if (data < minFontPt) {
            return {
                status: 0,
                code: 0,
                data: minFontPt,
            };
        } else if (data > 1000) {
            return {
                status: 0,
                code: 1,
                data: 1000,
            };
        } else {
            return {
                status: 1,
            };
        }
    }

    ft_getAlign(index: number) {
        let alignText = [
            ["left", "top"],
            ["center", "top"],
            ["right", "top"],
            ["justify", "top"],
            ["left", "middle"],
            ["center", "middle"],
            ["right", "middle"],
            ["justify", "middle"],
            ["left", "bottom"],
            ["center", "bottom"],
            ["right", "bottom"],
            ["justify", "bottom"],
        ];
        return alignText[index];
    }

    getRealAlignId(v: number, h: number) {
        let key = `${v}${h}`;
        let vhMapAlign = {
            "00": 0,
            "01": 1,
            "02": 2,

            "10": 4,
            "11": 5,
            "12": 6,

            "20": 8,
            "21": 9,
            "22": 10,
        };
        return vhMapAlign[key];
    }

    getRenderAlignID(align: number) {
        if (align === undefined || align === null) {
            return {
                vAlign: 1,
                hAlign: 1,
            };
        }
        /**
         * vAlign 垂直对齐
         * 0 top
         * 1 center
         * 2 bottom
         */
        /**
         * hAlign 水平对齐
         * 0 left
         * 1 center
         * 2 right
         */
        let alignMapVH = {
            0: "00", // top left
            1: "01", // top center
            2: "02", // top right
            3: "00", //  top aside
            4: "10", // center left
            5: "11", // center center
            6: "12", // center right
            7: "10", // center aside
            8: "20", // bottom left
            9: "21", // bottom center
            10: "22", // bottom right
            11: "20", // bottom aside
        };
        let value = alignMapVH[align].split("").map((v) => Number(v));

        return {
            vAlign: value[0],
            hAlign: value[1],
        };
    }

    ft_setSize(size: number) {
        let checkObj = this.ft_checkSizeOK(size);
        if (checkObj.status) {
            this.ft_endPreview();
            window["_view"].editStyle("size", size);
        }
        return checkObj;
    }

    ft_setChartSize(index: number, data: number) {
        this.ft_endPreview();
        window["_view"].processChartCMD("labelFontSize", {
            index: index,
            data: data,
        });
    }

    ft_setFamily(data: string) {
        this.ft_endPreview();
        window["_view"].editStyle("family", data);
    }

    ft_setChartFamily(index: number, data: string) {
        this.ft_endPreview();
        window["_view"].processChartCMD("labelFontFamily", {
            index: index,
            data: data,
        });
    }

    ft_setEchartFont(data) {
        let change = {};
        try {
            const option = JSON.parse(this.$store.state.newEchart.activeChartOption);
            const key = Object.keys(data);
            if (option && key.includes("fontSize")) {
                if (option.xAxis) {
                    change["xAxis"] = option.xAxis.map((item) => ((item.axisLabel.fontSize = data["fontSize"]), item));
                }
                if (option.yAxis) {
                    change["yAxis"] = option.yAxis.map((item) => ((item.axisLabel.fontSize = data["fontSize"]), item));
                }
                if (this.$store.state.newEchart.activeChartType == "sankey") {
                    change["series"] = option.series.map((item) => ((item.label.fontSize = data["fontSize"]), item));
                }
            }
        } catch (e) {}
        this.$bus.$emit("setEditEchartData", { textStyle: data, ...change });
    }

    ft_setListStyle(index: number) {
        window["_view"].editStyle("bullet", index);
    }

    ft_setTextPath(index: number) {
        window["_view"].editStyle("textOnPath", index);
    }

    ft_setAlign(index: number) {
        window["_view"].editStyle("align", this.ft_getAlign(index));
    }

    ft_setLineHeight(data: number) {
        window["_view"].editStyle("lineHeight", data);
    }

    ft_setFirstIndent(data: number) {
        window["_view"].editStyle("firstIndent", data);
    }

    ft_setLeftIndent(data: number) {
        window["_view"].editStyle("leftIndent", data);
    }

    ft_setRightIndent(data: number) {
        window["_view"].editStyle("rightIndent", data);
    }

    ft_setBefore(data: number) {
        // 段前缩进
        window["_view"].editStyle("before", data);
    }

    ft_setAfter(data: number) {
        // 段后缩进
        window["_view"].editStyle("after", data);
    }

    ft_setBold(data: boolean) {
        window["_view"].editStyle("bold", data);
    }

    ft_setChartBold(index: number, data: boolean) {
        window["_view"].processChartCMD("labelFontWeight", {
            index: index,
            data: data,
        });
    }

    ft_setItalic(data: boolean) {
        window["_view"].editStyle("italy", data);
    }

    ft_setChartItalic(index: number, data: boolean) {
        window["_view"].processChartCMD("labelFontStyle", {
            index: index,
            data: data,
        });
    }

    ft_setUnderline(data: boolean) {
        window["_view"].editStyle("underline", data);
    }

    ft_setSuperscript(data: boolean) {
        window["_view"].editStyle("superscript", data);
    }

    ft_setSubscript(data: boolean) {
        window["_view"].editStyle("subscript", data);
    }

    ft_setLineThrough(data: boolean) {
        window["_view"].editStyle("strikethrough", data);
    }

    /**preview */
    ft_endPreview() {
        window["_view"].hoverLeava();
    }
    ft_previewAlign(index: number) {
        window["_view"].setFontPreviewFunc("align", this.ft_getAlign(index));
    }
    ft_previewName(data: string) {
        window["_view"].setFontPreviewFunc("name", data);
    }
    ft_previewSize(data: number) {
        window["_view"].setFontPreviewFunc("size", data);
    }
}
